export default __webpack_public_path__ + "static/media/scorm-act.e81a3245.svg";